import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertDisplayType } from '@commonEnums/AlertDisplayType';
import { AlertService } from '@commonServices/alert.service';
import { RequestService } from '@commonServices/request.service';
import { AlertPositionType } from '@enums/alertPositionType';
import { Client as CatalogAPI, PreviewAndPublishInfoDto, PublishJobDto } from '@interfaces/HttpClient/CatalogApiModels';
import { Client as NaturalLanguageProcessingApi } from '@interfaces/HttpClient/NaturalLanguageProcessingApiModels';
import { firstValueFrom } from 'rxjs';
import { AdministrationService } from './administration.service';
import { TranslationService } from './translation.service';

@Injectable()
export class PreviewAndPublishService {

	constructor(
		private catalogApi: CatalogAPI,
		private nlpApi: NaturalLanguageProcessingApi,
		private requestService: RequestService,
		private administrationService: AdministrationService,
		private translationService: TranslationService,
		private alertService: AlertService<AlertPositionType>
	) { }

	async getPublishCatalogInformation(
		catalogId?: number
	): Promise<PreviewAndPublishInfoDto> {
		const id = catalogId ? catalogId : this.administrationService.getId();
		try {
			return await firstValueFrom(this.catalogApi
				.previewAndPublish_GetPreviewAndPublishInformation(id));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}


	async getPublishProgress(
		catalogId?: number
	): Promise<PublishJobDto> {
		const id = catalogId ? catalogId : this.administrationService.getId();
		try {
			return await firstValueFrom(this.catalogApi
				.previewAndPublish_GetPublishProgress(id));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async isKeywordsAnalyzeDone(catalogId?: number): Promise<boolean> {
		const id = catalogId ? catalogId : this.administrationService.getId();
		try {
			return await firstValueFrom(this.nlpApi
				.keywordsApp_IsKeywordsAnalyzeDone(id));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async publishCatalog(keypart: string, catalogId?: number): Promise<void> {
		const id = catalogId ? catalogId : this.administrationService.getId();
		try {
			return await firstValueFrom(this.catalogApi
				.previewAndPublish_PublishCatalog(id));
		} catch (e) {

			this.alertService.sendMessage(AlertPositionType.Global, AlertDisplayType.Danger, this.translationService.getByKey(
				`${keypart}error`
			));

			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async deleteCatalog(catalogId?: number): Promise<void> {
		const id = catalogId ? catalogId : this.administrationService.getId();
		try {
			await firstValueFrom(this.catalogApi
				.previewAndPublish_DeletePublishedCatalog(id));
			this.alertService.sendMessage(AlertPositionType.Global, AlertDisplayType.Success, this.translationService.getByKey(
				"catalog.publish.delete.deleteCommited"
			));
			return;

		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}
}
